import './App.css';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import Header from './components/Header/Header';
import Home from './components/Home/Home';
import Signup from './components/Signup/Signup';
import { createContext, useState } from 'react';
import Login from './components/Login/Login';
import MealItem from './components/MealItem/MealItem';
import PrivateRoute from './components/PrivateRoute/PrivateRoute';
import Checkout from './components/Checkout/Checkout';
import Shipment from './components/Shipment/Shipment';

export const UserContext = createContext();
export const NewUserContext = createContext();
export const CountContext = createContext()
export const OrderDetails = createContext();
export const OrdersContext = createContext();

function App() {
  const [loggedInUser, setLoggedInUser] = useState({})
  const [newUser, setNewUser] = useState(true)
  const [count, setCount] = useState(1);
  const [orderDetails, setOrderDetails] = useState({});
  const [orders, setOrders] = useState([]);

  return (
    <UserContext.Provider value={[loggedInUser, setLoggedInUser]}>
    <NewUserContext.Provider value={[newUser, setNewUser]}>
    <CountContext.Provider value={[count, setCount]}>
    <OrderDetails.Provider value={[orderDetails, setOrderDetails]}>
    <OrdersContext.Provider value={[orders, setOrders]} >
      <Router>
      <Header/>
        <Switch>
          <Route exact path="/">
            <Home/>
          </Route>
          <PrivateRoute path="/checkout">
            <Checkout />
          </PrivateRoute>
          <Route path="/login">
            <Login/>
          </Route>
          <Route path="/signup">
            <Signup/>
          </Route>
          <Route path="/shipment">
            <Shipment />
          </Route>
          <PrivateRoute path="/meal/:id">
            <MealItem />
          </PrivateRoute>
        </Switch>
      </Router>
    </OrdersContext.Provider> 
    </OrderDetails.Provider>
    </CountContext.Provider>
    </NewUserContext.Provider>
    </UserContext.Provider>
  );
}

export default App;
